import "./Body.css";
import { useMemo, useState } from "react";
import StarfieldBackground from "./StarfieldBackground";
import { BookDemoModal } from "./BookDemoModal";

interface BodyProps {
    onWaitlistClick: (email: string) => Promise<void> | void;
    showModal: boolean;
    onModalClose: () => void;
}

export function Body({ onWaitlistClick, showModal, onModalClose }: BodyProps) {
    const [input, setInput] = useState<string>("");
    const email = useMemo(() => input.trim(), [input]);

    const handleJoinWaitlist = async () => {
        await onWaitlistClick(email);
        setInput("");
    };

    return (
        <main className="landing-main">
            <div className="landing-bg" aria-hidden="true">
                <StarfieldBackground />
            </div>

            {/* Book Demo Modal */}
            <BookDemoModal showModal={showModal} onModalClose={onModalClose} />

            <div className="landing-foreground">
                <section className="hero">
                    <div className="hero-left">
                        <h1 className="hero-title">
                            Monitor, Evaluate,
                            <br />
                            Optimize Your AI Agents
                        </h1>

                        <p className="hero-subtitle">
                            AI agents hallucinate in production. Get decision-level visibility into handoffs and
                            tool calls to catch drift and failures before users complain.
                        </p>

                        <div className="waitlist-wrap">
                            <div className="waitlist">
                                <input
                                    className="waitlist-input"
                                    type="email"
                                    placeholder="Enter email for early access"
                                    autoComplete="email"
                                    value={input}
                                    onChange={(e) => setInput(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") handleJoinWaitlist();
                                    }}
                                />
                                <button className="waitlist-btn" type="button" onClick={handleJoinWaitlist}>
                                    Join Waitlist
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="hero-right" aria-hidden="true" />
                </section>
            </div>
        </main>
    );
}
